// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__3svfe","title":"style_title__HOWK6","labelContainer":"style_labelContainer__7_TxF","valueBlock":"style_valueBlock__toQZA","tooltip":"style_tooltip__GnwhW"};